import {
  factorsViewSlice,
  FACTORS_VIEW_PREFERENCE_BASE,
  selectFactorsViewPanel,
} from "connected-components/dashboard/store/factors-view-slice"
import { createTemplateChartHook } from "connected-components/dashboard/hooks/create-template-chart-hook"

// Per-template chart settings for the factors-view panel slice (content-set, performance).
export const useFactorsViewTemplateChart = createTemplateChartHook({
  preferenceBase: FACTORS_VIEW_PREFERENCE_BASE,
  selectPanel: selectFactorsViewPanel,
  setTemplateChartSetting: factorsViewSlice.actions.setTemplateChartSetting,
  seedTemplateChart: factorsViewSlice.actions.seedTemplateChart,
})
